/**
 * GXV 3450 默认值
 */
const d: ConfigParams = {
  settings: {
    phonebook: 1,
    layout: 1,
    background: 1,
    screensaver: 1,
    language: 1,
    taskbar: 1,
    callset: 1,
    // fitscreen: 1,
  },
  phonebook: {
    downloadClearOld: 0,
    downloadClearOldMode: 0,
    downloadRmRedup: 0,
    downloadRmRedupMode: 0,
    downloadFileEncoding: 'UTF-8',
    downloadMode: 0,
    downloadPassword: '',
    downloadUrl: '',
    downloadUsername: '',
    updateInterval: 0,
    importClearOld: 0,
    importRmRedup: 0,
    importClearOldMode: 0,
    importRmRedupMode: 0,
    importFileEncoding: 'UTF-8',
    importFileType: 0,
    exportFileEncoding: 'UTF-8',
    exportFileType: 0,
    iceNumber: '',
  },
  background: {
    wallpaper: 0,
    disableChangeWallpaper: 0,
  },
  callset: {
    oneway: '9,0',
    conference: '15,0',
  },
  screensaver: {
    saverType: 1,
    clockType: 2,
    nightMode: 1,
    screenType: 2,
    screenTime: 120,
    screenLcdOff: 180,
    screenInterval: 3,
    localImg: '',
    netImg: '',
  },
  language: {
    langApply: 1,
    langCode: 'en,US',
    langFile: '',
    inputMethod: 0,
    custInputMethodName: '',
    custInputMethodInfoName: '',
    custInputMethodInfoPackageName: '',
  },
  taskbar: {
    tasks:
      'wifi,bt,gsdnd,gsvoice,gslock,gsautoanswer,gstransfer,gsehs,gsscreenshot,gsnetwork',
    disable: 0,
  },
  fitscreen: {
    teams: 1,
    skype: 1,
    youtube: 1,
  },
  menu: {
    builtinApp: [
      {
        apkName: 'FileManager',
        className: 'com.base.module.filemanager.activity.MainActivity',
        packageName: 'com.base.module.filemanager',
        hide: 0,
      },
      {
        apkName: 'Browser',
        className: 'com.android.browser.BrowserActivity',
        packageName: 'com.android.browser',
        hide: 0,
      },
      {
        apkName: 'Phone',
        className: 'com.base.module.phone.view.activity.DialMainActivity',
        packageName: 'com.base.module.phone',
        hide: 0,
      },
      {
        apkName: 'Call History',
        className: 'com.base.module.callhistory.CallHistoryActivity',
        packageName: 'com.base.module.callhistory',
        hide: 0,
      },
      {
        apkName: 'Contacts',
        className: 'com.android.contacts.activities.MainActivity',
        packageName: 'com.android.contacts',
        hide: 0,
      },
      {
        apkName: 'Settings',
        className: 'com.android.settings.gs.activity.SettingsActivity',
        packageName: 'com.android.settings',
        hide: 0,
      },
      {
        apkName: 'GS Market',
        className: 'com.base.module.market.main.Gs33XXMainActivity',
        packageName: 'com.base.module.market',
        hide: 0,
      },
      {
        apkName: 'Calculator',
        className: 'com.android.calculator2.Calculator',
        packageName: 'com.android.calculator2',
        hide: 0,
      },
      {
        apkName: 'Camera',
        className: 'com.android.camera.CameraLauncher',
        packageName: 'com.android.camera2',
        hide: 0,
      },
      {
        apkName: 'Conf',
        className: 'com.base.module.phone.view.activity.SwitchToConfView',
        packageName: 'com.base.module.phone',
        hide: 0,
      },
      {
        apkName: 'MPK',
        className: 'com.base.module.mpk.ui.activity.MainActivity',
        packageName: 'com.base.module.mpk',
        hide: 0,
      },
      {
        apkName: 'Voice Mail',
        className: 'com.base.module.voicemail.VMActivity',
        packageName: 'com.base.module.voicemail',
        hide: 0,
      },
      {
        apkName: 'GsMessage',
        className: 'com.base.module.message.activity.MainActivity',
        packageName: 'com.base.module.message',
        hide: 0,
      },
      {
        apkName: 'Backup',
        className: 'com.base.module.backup.ui.activity.MainActivity',
        packageName: 'com.base.module.backup',
        hide: 0,
      },
      {
        apkName: 'Xsi',
        className: 'com.base.module.broadsoft.xsi.view.LoginActivity',
        packageName: 'com.base.module.broadsoft.xsi.view',
        hide: 0,
      },
      {
        apkName: 'Recorder',
        className: 'com.base.module.recordingmanagement.ui.FirstActivity',
        packageName: 'com.base.module.recordingmanagement',
        hide: 0,
      },
      {
        apkName: 'BroadsoftXmpp',
        className: 'com.base.module.broadsoft.xmpp.ui.activity.LoginActivity',
        packageName: 'com.base.module.broadsoft.xmpp',
        hide: 0,
      },
      {
        apkName: 'FTP',
        className: 'com.base.module.control.ServerControlActivity',
        packageName: 'com.base.module.control',
        hide: 0,
      },
      {
        apkName: 'State Detection',
        className: 'com.base.module.statedetection.MainActivity',
        packageName: 'com.base.module.statedetection',
        hide: 0,
      },
      {
        apkName: 'Schedule',
        className: 'com.base.module.schedule.view.activity.MainActivity',
        packageName: 'com.base.module.schedule',
        hide: 0,
      },
      {
        apkName: 'HwContacts',
        className: 'com.gs.hwcontacts.ui.main.MainActivity',
        packageName: 'com.gs.hwcontacts',
        hide: 0,
      },
      {
        apkName: 'DeskClock',
        className: 'com.android.deskclock.DeskClock',
        packageName: 'com.android.deskclock',
        hide: 0,
      },
      {
        apkName: 'OneClickConfig',
        className:
          'com.android.settings.gs.advanced.upgrade.ProfileCodeActivity',
        packageName: 'com.android.settings',
        hide: 0,
      },
      {
        apkName: 'LDAP',
        className: 'com.android.contacts.LDAPActivity',
        packageName: 'com.android.contacts',
        hide: 0,
      },
      {
        apkName: 'Call Center',
        className: 'com.base.module.phone.view.activity.CallCenterActivity',
        packageName: 'com.base.module.phone',
        hide: 0,
      },
    ],
    thirdApp: [],
  },
  desktop: {
    homeIndex: 0,
    desktopNum: 4,
    hotseatNum: 3,
    appPreScreen: 1,
    // keepCustomScreen: 1,
    disableDestManage: 0,
    disableTouchBtns: 0,
    disableRemoveWidget: 0,
    disableFocusMode: 0,
  },
  layout: {
    sider: [
      {
        packageName: 'com.base.module.phone',
        className: 'com.base.module.phone.view.activity.DialMainActivity',
      },
      {
        packageName: 'com.android.contacts',
        className: 'com.android.contacts.activities.MainActivity',
      },
      {
        packageName: 'com.base.module.callhistory',
        className: 'com.base.module.callhistory.CallHistoryActivity',
      },
    ],
    folder: [],
    shortcut: [],
    widget: [
      {
        packageName: 'com.base.module.mpk',
        className: 'com.base.module.mpk.ui.widget.MPKWidget',
        screen: 0,
        x: 0,
        y: 0,
        spanX: 2,
        spanY: 3,
      },
      {
        packageName: 'com.android.deskclock',
        className: 'com.android.alarmclock.DigitalAppWidgetProvider',
        screen: 0,
        x: 2,
        y: 1,
        spanX: 2,
        spanY: 1,
      },
    ],
    app: [
      {
        packageName: 'com.base.module.filemanager',
        className: 'com.base.module.filemanager.activity.MainActivity',
        screen: 1,
        x: 0,
        y: 0,
      },
      {
        packageName: 'com.base.module.mpk',
        className: 'com.base.module.mpk.ui.activity.MainActivity',
        screen: 1,
        x: 1,
        y: 0,
      },
      {
        packageName: 'com.base.module.voicemail',
        className: 'com.base.module.voicemail.VMActivity',
        screen: 1,
        x: 2,
        y: 0,
      },
      {
        packageName: 'com.base.module.market',
        className: 'com.base.module.market.main.Gs33XXMainActivity',
        screen: 1,
        x: 3,
        y: 0,
      },
      {
        packageName: 'com.android.settings',
        className: 'com.android.settings.gs.activity.SettingsActivity',
        screen: 1,
        x: 4,
        y: 0,
      },
      {
        packageName: 'com.android.calculator2',
        className: 'com.android.calculator2.Calculator',
        screen: 1,
        x: 0,
        y: 1,
      },
      {
        packageName: 'com.android.browser',
        className: 'com.android.browser.BrowserActivity',
        screen: 1,
        x: 1,
        y: 1,
      },
      {
        packageName: 'com.base.module.message',
        className: 'com.base.module.message.activity.MainActivity',
        screen: 1,
        x: 2,
        y: 1,
      },
      {
        packageName: 'com.base.module.backup',
        className: 'com.base.module.backup.ui.activity.MainActivity',
        screen: 1,
        x: 3,
        y: 1,
      },
      {
        packageName: 'com.base.module.recordingmanagement',
        className: 'com.base.module.recordingmanagement.ui.FirstActivity',
        screen: 1,
        x: 4,
        y: 1,
      },
      {
        packageName: 'com.base.module.statedetection',
        className: 'com.base.module.statedetection.MainActivity',
        screen: 1,
        x: 0,
        y: 2,
      },
      {
        packageName: 'com.base.module.schedule',
        className: 'com.base.module.schedule.view.activity.MainActivity',
        screen: 1,
        x: 1,
        y: 2,
      },
      {
        packageName: 'com.android.deskclock',
        className: 'com.android.deskclock.DeskClock',
        screen: 1,
        x: 2,
        y: 2,
      },
      {
        packageName: 'com.base.module.broadsoft.xmpp',
        className: 'com.base.module.broadsoft.xmpp.ui.activity.LoginActivity',
        screen: 1,
        x: 3,
        y: 2,
      },
      {
        packageName: 'com.base.module.broadsoft.xsi.view',
        className: 'com.base.module.broadsoft.xsi.view.LoginActivity',
        screen: 1,
        x: 4,
        y: 2,
      },
      {
        packageName: 'com.gs.hwcontacts',
        className: 'com.gs.hwcontacts.ui.main.MainActivity',
        screen: 2,
        x: 0,
        y: 0,
      },
      {
        packageName: 'com.android.settings',
        className:
          'com.android.settings.gs.advanced.upgrade.ProfileCodeActivity',
        screen: 2,
        x: 1,
        y: 0,
      },
      {
        packageName: 'com.android.camera2',
        className: 'com.android.camera.CameraLauncher',
        screen: 2,
        x: 2,
        y: 0,
      },
      {
        packageName: 'com.android.contacts',
        className: 'com.android.contacts.LDAPActivity',
        screen: 2,
        x: 3,
        y: 0,
      },
      {
        packageName: 'com.base.module.phone',
        className: 'com.base.module.phone.view.activity.CallCenterActivity',
        screen: 2,
        x: 4,
        y: 0,
      },
    ],
  },
};
export default d;
